/**
 * Configuración del kit de soporte (`src/soporte`, copia del kit compartido:
 * no se edita aquí) para los dos canales de Proveedores.
 *
 * - Interno: Bearer de Entra (MSAL). Se registra al arrancar con
 *   `configurarSoporte`, así el botón de la barra no necesita props.
 * - Portal: cookie de sesión del proveedor (`credentials: 'include'`); la barra
 *   del portal y la pantalla de error lo pasan como `config`.
 *
 * La entidad es la oportunidad: se toma de la pantalla de detalle del admin y
 * del expediente del portal.
 */
import type { SoporteConfig, SoporteEntidad } from '../soporte'
import { API_BASE_URL, authHeaders } from '../services/api'

const OPORTUNIDAD: SoporteEntidad = {
  etiqueta: 'Oportunidad',
  placeholder: 'Id de la oportunidad, si el problema es de una',
  rutas: [/^\/oportunidades\/(\d+)(?:\/|$)/, /^\/p\/expediente\/(\d+)(?:\/|$)/],
}

export const SOPORTE_INTERNO: SoporteConfig = {
  endpoint: `${API_BASE_URL}/bug-reports`,
  headers: authHeaders,
  entidad: OPORTUNIDAD,
}

export const SOPORTE_PORTAL: SoporteConfig = {
  endpoint: `${API_BASE_URL}/portal/bug-reports`,
  credentials: 'include',
  entidad: OPORTUNIDAD,
}

/**
 * Canal del reporte según la ruta, o `null` si ahí no hay sesión posible
 * (logins y pantallas públicas): el botón no se muestra.
 */
export function soportePorRuta(pathname: string): SoporteConfig | null {
  if (pathname === '/p/login' || pathname.startsWith('/p/login/')) return null
  if (pathname.startsWith('/registro-distribuidor') || pathname.startsWith('/correccion')) {
    return null
  }
  if (pathname === '/p' || pathname.startsWith('/p/')) return SOPORTE_PORTAL
  return SOPORTE_INTERNO
}
